/**
 * Values of an asset's `provider` field. Absent for Showit media-server assets;
 * set for external images, whose resize contract is picked by provider.
 */

/** @type {"pexels"} */
export const PEXELS = "pexels";

export const AssetProvider = {
  PEXELS,
};

/**
 * @typedef {typeof AssetProvider[keyof typeof AssetProvider]} AssetProviderValue
 */
